<script lang="ts">
    import type {ViewLayout} from 'shared/layouts';
    import type {SvelteComponentConstructor} from 'core/types';
    import IconInfoBlockPart from './IconInfoBlockPart.svelte';
    import FullWidthDividerPart from './FullWidthDividerPart.svelte';
    import BuiltLayoutPart from './BuiltLayoutPart.svelte';

    export let layout: ViewLayout;
    export let supportedComponents: Record<string, SvelteComponentConstructor>;

    $: allSupportedComponents = {
        ...supportedComponents,
        fullWidthDivider: FullWidthDividerPart,
        iconInfoBlock: IconInfoBlockPart
    }
</script>

<div class="kp-layout" style:--main-gap={layout.settings.mainLayoutGap}>
    {#each layout.parts as part}
        <BuiltLayoutPart {part}
                         supportedComponents={allSupportedComponents}
                         layoutSettings={layout.settings}/>
    {/each}
</div>

<style lang="less">
    .kp-layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--main-gap);
    }
</style>